<div class="home-page-main-container">

  <div class="img-vector-CV-wrapper">
    <section class="main-section">
      <div class="lef-side">
        <h1>{{ 'home_page.resume_builder' | translate }}</h1>

        <h2 class="mb-30 fs-16 l-height-initial max-w-500">
          {{ 'home_page.creation_choices' | translate }}
        </h2>

        <div class="buttons-wrap">
          <a class="sf-btn-primary" (click)="trackResumeAction('manual_builder')"
             [routerLink]="appStateService.route_paths | lngRoute: 'dashboard' : appStateService.dateTime">
            {{ 'home_page.build_my_resume' | translate }}
          </a>

          <a class="ai-resume-cta" (click)="trackResumeAction('ai_generator')"
             [routerLink]="appStateService.route_paths | lngRoute: 'ai_resume_generator' : appStateService.dateTime">
            <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z"/></svg>
            {{ 'home_page.generate_with_ai' | translate }}
          </a>
        </div>

        <div class="existing-resume-cta">
          <span>{{ 'home_page.already_have_resume' | translate }}</span>
          <a (click)="trackResumeAction('ats_checker')"
             [routerLink]="appStateService.route_paths | lngRoute: 'ats_checker' : appStateService.dateTime">
            {{ 'home_page.check_with_ats' | translate }}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6"/></svg>
          </a>
        </div>

      </div>

      <div class="right-side"></div>
    </section>

    <sf-why-use-us-section/>
  </div>

  <div class="S-logo-sections">
    @defer (hydrate on idle) {
      <sf-resume-examples-section/>
    }

    <div class="find-new-career-section">
      <section>
        <div class="small-desc">selfcv</div>

        <h2>{{ 'home_page.new_career' | translate }}</h2>

        <div class="mb-52">{{ 'home_page.start_building' | translate }}</div>

        <a
          class="sf-btn-primary w-fit min-w-250"
          [routerLink]="appStateService.route_paths | lngRoute: 'cv_templates' : appStateService.dateTime">
          {{ 'home_page.browse_resume' | translate }}
        </a>
      </section>
    </div>

    <div class="build-your-resume-section">
      <section>
        <div class="top-part">
          <div class="blue-small-desc">{{ 'home_page.find_solutions' | translate }}</div>

          <h2 [innerHTML]="'home_page.build_your_resume' | translate"></h2>

          <p>{{ 'home_page.just_follow' | translate }}</p>
        </div>

        <div class="body-part">
          @for (step of resumeBuildSteps; track $index) {
            <div class="step-item">
              <i class="{{step.icon}}"></i>
              <div>{{ step.title | translate }}</div>
              <p>{{ step.desc  | translate }}</p>
            </div>
          }

          <i class="sf-icon-icon-logo"></i>
        </div>

      </section>
    </div>

  </div>

  <sf-users-review/>

  <sf-users-review-grid/>

  <sf-more-then-section/>

  <sf-resume-examples-banner/>

  @if (appStateService.FAQObj) {
    <sf-faq-section [faq]="appStateService.FAQObj.homePage"/>
  }

</div>
